import React from "react";

function PhaseComplete({ children }) {
  return <div className="ee-phase-complete">{children}</div>;
}

export default PhaseComplete;
